// extracted by mini-css-extract-plugin
module.exports = {"container":"HorizontalScrollTable_container__1WFKg","sticky":"HorizontalScrollTable_sticky__Rbgbl"};